import { Link } from 'react-router-dom';

export function NavLink({ href, children }) {
  const isHash = typeof href === 'string' && href.startsWith('#');
  const className = 'inline-block rounded-lg px-2.5 py-1.5 text-sm font-medium text-slate-700 hover:text-slate-950 hover:bg-white/45 transition-colors whitespace-nowrap';
  if (isHash) {
    return (
      <a href={href} className={className}>
        {children}
      </a>
    );
  }
  return (
    <Link to={href} className={className}>
      {children}
    </Link>
  );
}
